import { BASE_URL } from "../../api/urls";
import { store } from "../../store/store";

export default (accountId) => {
  if (!accountId) return null;
  const version = store.getState().account.logoVersion || 0;
  return `${BASE_URL}/company/${accountId}/logo?version=${version.toString()}`;
};
